/**
 * Where "View dashboard" goes from a saved scan.
 *
 * `?cookie=1` opens the dashboard as the client, signed in by the scan link's
 * cookie — right for a client who scanned on their own phone, wrong for a
 * coach, who landed in the client's view with no Target tab and no notes. A
 * coach is signed in; a client on a scan link is not.
 */
export const dashboardHrefAfterScan = (profileID: string, signedIn: boolean) =>
    `/dashboard/${profileID}?show=avatar${signedIn ? '' : '&cookie=1'}`;
